import { watch } from 'vue'
import { useDeviceStore } from '@/stores/device'
import { ReportEvents } from '@rapoo/device-sdk'
import { storeToRefs } from 'pinia'

export const useKeyboardReport = (_cb: (data: any) => void) => {
  const deviceStore = useDeviceStore()
  const { currentDevice } = storeToRefs(deviceStore)

  let activeCallback: ((data: any) => void) | null = null

  const setup = (callback: (data: any) => void) => {
    // 移除旧的监听
    if (activeCallback && currentDevice.value) {
      currentDevice.value.off(ReportEvents.KeyCalibUpload, activeCallback)
    }
    activeCallback = callback
    if (currentDevice.value) {
      currentDevice.value.on(ReportEvents.KeyCalibUpload, callback)
    }
  }

  const teardown = () => {
    if (activeCallback && currentDevice.value) {
      currentDevice.value.off(ReportEvents.KeyCalibUpload, activeCallback)
      activeCallback = null
    }
  }

  watch(
    () => currentDevice.value,
    (newVal, oldVal) => {
      if (oldVal && activeCallback) {
        oldVal.off(ReportEvents.KeyCalibUpload, activeCallback)
      }
      if (newVal && activeCallback) {
        newVal.on(ReportEvents.KeyCalibUpload, activeCallback)
      }
    },
  )

  return { setup, teardown }
}
